module.exports = __webpack_public_path__ + "static/media/brand-kit.c9dbb176.png";